import { Link } from 'react-router-dom';
import { Button } from '@upmc/ims.component-library';

import * as utils from '../../../utils';
import classes from '../UserAccessReview.module.scss';
import { UAR_CONSTANTS } from '../util/constants';

const Profile = props => {
	const { details, navigation = true } = props;

	const displayName = details
		? details.isServiceAccount
			? `${details.familiarEsoId} (Service Account)`
			: details.firstName +
			  ' ' +
			  details.middleInitial +
			  ' ' +
			  details.lastName
		: 'unknown';

	const layout = details ? (
		<section
			id='profileDetails'
			className={utils.concatenateClassNames(
				['profile', 'profile__container'],
				classes
			)}
		>
			<div
				className={utils.concatenateClassNames(
					['profile__item', 'profile-details__item'],
					classes
				)}
			>
				<div
					className={utils.concatenateClassNames(['title'], classes)}
				>
					{displayName}
				</div>
				{details.type === UAR_CONSTANTS.EMPLOYEE_KEY && (
					<div>
						<span
							className={utils.concatenateClassNames(
								['category'],
								classes
							)}
						>
							Employee ID:
						</span>{' '}
						{details.employeeId ? details.employeeId : 'N/A'}
					</div>
				)}
				{details.type === UAR_CONSTANTS.NON_EMPLOYEE_KEY && (
					<div>
						<span
							className={utils.concatenateClassNames(
								['category'],
								classes
							)}
						>
							Company:
						</span>{' '}
						{details.nonEmployeeCompanyName
							? details.nonEmployeeCompanyName
							: 'N/A'}
					</div>
				)}
				<div>
					<span
						className={utils.concatenateClassNames(
							['category'],
							classes
						)}
					>
						Email:
					</span>{' '}
					{details.email ? details.email : 'N/A'}
				</div>
				<div>
					<span
						className={utils.concatenateClassNames(
							['category'],
							classes
						)}
					>
						NTID:
					</span>{' '}
					{details.ntid ? details.ntid : 'N/A'}
				</div>
				<div>
					<span
						className={utils.concatenateClassNames(
							['category'],
							classes
						)}
					>
						Date Last Validated:
					</span>{' '}
					{details.dateValidated
						? utils.prettyDateFormat(details.dateValidated)
						: 'N/A'}
				</div>
				<div>
					<span
						className={utils.concatenateClassNames(
							['category'],
							classes
						)}
					>
						Date Validation Due:
					</span>{' '}
					{details.dateValidationDue
						? utils.prettyDateFormat(details.dateValidationDue)
						: 'N/A'}
				</div>
				{details.isExpired ? (
					<span
						className={utils.concatenateClassNames(
							['text--expired'],
							classes
						)}
					>
						(Expired)
					</span>
				) : null}
				{details.willExpireSoon ? (
					<span
						className={utils.concatenateClassNames([
							'text--expired',
						])}
					>
						(Expiring Soon)
					</span>
				) : null}
				<div>
					<span
						className={utils.concatenateClassNames(
							['category'],
							classes
						)}
					>
						Phone Number:
					</span>{' '}
					{details.phoneNumber ? details.phoneNumber : 'none'}
				</div>
				{navigation ? (
					<div>
						<Link
							to={{
								pathname: '/UserAccessReview/Edit',
								search: '?esoFiId=' + details.esoFiId,
							}}
						>
							<Button variant='outlined'>
								Edit User Information
							</Button>
						</Link>
					</div>
				) : null}
			</div>
			<div
				className={utils.concatenateClassNames(
					[
						'profile__item',
						'profile-button__item',
						'profile-button__container',
					],
					classes
				)}
			>
				<Link
					to={{
						pathname: '/UserAccessReview/AccountDetails',
						search: '?esoFiId=' + details.supervisorEsoFiIds[0],
					}}
					className={utils.concatenateClassNames(
						['button__link--reset'],
						classes
					)}
				>
					<Button fullWidth={true} variant='outlined'>
						View Manager
					</Button>
				</Link>
				<Link
					to={{
						pathname: '/UserAccessReview/OrgChart',
						search: '?esoFiId=' + details.esoFiId,
					}}
					className={utils.concatenateClassNames(
						['button__link--reset'],
						classes
					)}
				>
					<Button fullWidth={true} variant='outlined'>
						View Org Chart
					</Button>
				</Link>
				{navigation ? (
					<>
						{details.type.toLowerCase() ===
						UAR_CONSTANTS.NON_EMPLOYEE_KEY.toLowerCase() ? (
							<Link
								to={{
									pathname: '/UserAccessReview/Reassign',
									search: '?esoFiId=' + details.esoFiId,
								}}
								className={utils.concatenateClassNames(
									['button__link--reset'],
									classes
								)}
							>
								<Button fullWidth={true} variant='outlined'>
									Reassign
								</Button>
							</Link>
						) : null}
						{details.type.toLowerCase() ===
						UAR_CONSTANTS.NON_EMPLOYEE_KEY.toLowerCase() ? (
							<Link
								to={{
									pathname: '/UserAccessReview/Renew',
									search: '?esoFiId=' + details.esoFiId,
								}}
								className={utils.concatenateClassNames(
									['button__link--reset'],
									classes
								)}
							>
								<Button fullWidth={true} variant='outlined'>
									Validate and Renew
								</Button>
							</Link>
						) : (
							<Link
								to={{
									pathname: '/UserAccessReview/Validate',
									search: '?esoFiId=' + details.esoFiId,
								}}
								className={utils.concatenateClassNames(
									['button__link--reset'],
									classes
								)}
							>
								<Button fullWidth={true} variant='outlined'>
									Review and Validate
								</Button>
							</Link>
						)}

						<Link
							to={{
								pathname: '/UserAccessReview/Delegate',
								search: '?esoFiId=' + details.esoFiId,
							}}
							className={utils.concatenateClassNames(
								['button__link--reset'],
								classes
							)}
						>
							<Button
								value=''
								fullWidth={true}
								variant='outlined'
							>
								Delegate
							</Button>
						</Link>
						<Link
							to={{
								pathname: '/UserAccessReview/Terminate',
								search: '?esoFiId=' + details.esoFiId,
							}}
							className={utils.concatenateClassNames(
								['button__link--reset'],
								classes
							)}
						>
							<Button fullWidth={true} variant='outlined'>
								Terminate
							</Button>
						</Link>
					</>
				) : null}
			</div>
		</section>
	) : null;

	return layout;
};

export default Profile;
